import { useEffect, useState } from "react";
import ProductosHeader from "./components/ProductosHeader";
import ProductosFilters from "./components/ProductosFilters";
import ProductosTable from "./components/ProductosTable";
import ExportExcelButton from "./components/ExportExcelButton";
import { getProductosEntregas } from "../../../services/financiero/productosEntregasService";

export default function ProductosEntregasPage() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filters, setFilters] = useState({
    producto: null,
    po: null,
    municipio: null,
    proyecto: null
  });

  useEffect(() => {
    getProductosEntregas().then((res) => {
      setData(res);
      setFilteredData(res);
    });
  }, []);

  // 🔥 FILTROS ROBUSTOS
  useEffect(() => {
    let result = [...data];

    if (filters.producto) {
      result = result.filter(d =>
        d.nombre_producto?.toLowerCase().includes(filters.producto.toLowerCase())
      );
    }

    if (filters.po) {
      result = result.filter(d =>
        String(d.Numero_PO || "").toLowerCase().includes(filters.po.toLowerCase())
      );
    }

    if (filters.municipio) {
      result = result.filter(d =>
        (d.municipio || "") === filters.municipio
      );
    }

    if (filters.proyecto) {
      result = result.filter(d =>
        (d.codigo_proyecto || "") === filters.proyecto
      );
    }

    setFilteredData(result);
  }, [filters, data]);

  const handleFilter = (type, value) => {
    setFilters(prev => ({
      ...prev,
      [type]: value || null
    }));
  };

  // 🔥 LIMPIAR FILTROS
  const clearFilters = () => {
    setFilters({
      producto: null,
      po: null,
      municipio: null,
      proyecto: null
    });
    setFilteredData(data);
  };

  // 🔥 OPCIONES LIMPIAS (SIN NULL NI DUPLICADOS)
  const productos = [...new Set(data.map(d => d.nombre_producto).filter(Boolean))];
  const municipios = [...new Set(data.map(d => d.municipio).filter(Boolean))];
  const pos = [...new Set(data.map(d => d.Numero_PO).filter(Boolean))];
  const proyectos = [
    ...new Map(
      data
        .filter(d => d.codigo_proyecto)
        .map(d => [d.codigo_proyecto, {
          codigo: d.codigo_proyecto,
          proyecto: d.nombre_proyecto || d.codigo_proyecto
        }])
    ).values()
  ];

  return (
    <div className="container">
      <ProductosHeader />

      <ProductosFilters
        productos={productos}
        municipios={municipios}
        pos={pos}
        proyectos={proyectos}
        filters={filters}
        onFilter={handleFilter}
        onClear={clearFilters}
        extra={<ExportExcelButton data={filteredData} />}
      />

      <ProductosTable data={filteredData} />
    </div>
  );
}